// extracted by mini-css-extract-plugin
export default {"CardContainer":"ChallengeKnowledgeCheckStart_CardContainer__xIDGP"};